import {borderRadius, fontsSize} from "./UIElements/Elements";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMessage} from "@fortawesome/free-solid-svg-icons";

const OrderItem = ({
                       id,
                       productId,
                       productName,
                       productPrice,
                       quantity,
                       createdAt,
                       isNew,
                       isSelected,
                       onSelect,
                       onDoubleClick,
                       comment
                   }) => {
    return (
        <div key={id}
             id={id}
             onClick={() => onSelect(id)}
             onDoubleClick={onDoubleClick} // Select item on click
             className={`first:mt-0 last:mb-0 relative w-full min-h-[5vh] h-auto mt-[1vh] mb-[1vh] 
                ${isNew ? 'bg-cyan-600' : 'bg-gray-200 text-black border-b-2 '} 
                flex justify-between items-center px-[15px] flex-wrap ${borderRadius.small}
                ${isSelected ? 'bg-cyan-950 border-2 border-yellow-400' : ''} cursor-pointer transition-all duration-200 max-lg:min-h-[3vh] max-lg:h-[3vh] max-lg:w-[100%]`}
        >
            <div
                className={`w-[33%] h-auto flex justify-start items-center ${fontsSize.m} max-lg:h-[3vh] max-lg:${fontsSize.s}`}>
                {productName}
                {comment && (
                    <span className="ml-2 group relative">
                        <FontAwesomeIcon icon={faMessage} className="text-white"/>
                        <div
                            className="absolute min-w-[15vw] max-w-[15vw] left-0 top-[100%] hidden group-hover:block text-white bg-gray-700 p-[1vh] rounded mt-[1vh] opacity-0 transition-opacity duration-1000 ease-in-out group-hover:opacity-100 z-30">
                            {comment}
                        </div>
                    </span>
                )}
            </div>
            <div className={`w-[33%] flex justify-center items-center ${fontsSize.m}  max-lg:${fontsSize.s}`}>
                {quantity}
            </div>
            <div className={`w-[33%] flex justify-end items-center ${fontsSize.m}  max-lg:${fontsSize.s}`}>
                {Number(productPrice * quantity).toLocaleString()} den
            </div>
        </div>
    );
};

export default OrderItem;
